/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Freezing_Drizzle_DenseInputs */

const en_ui_weather_freezing_drizzle_dense = /** @type {(inputs: Ui_Weather_Freezing_Drizzle_DenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heavy freezing drizzle`)
};

const de_ui_weather_freezing_drizzle_dense = /** @type {(inputs: Ui_Weather_Freezing_Drizzle_DenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gefrierender Nieselregen`)
};

/**
* | output |
* | --- |
* | "Heavy freezing drizzle" |
*
* @param {Ui_Weather_Freezing_Drizzle_DenseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_freezing_drizzle_dense = /** @type {((inputs?: Ui_Weather_Freezing_Drizzle_DenseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Freezing_Drizzle_DenseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_freezing_drizzle_dense(inputs)
	return de_ui_weather_freezing_drizzle_dense(inputs)
});